import { z } from "zod";

export const loginSchema = z.object({
    mobileno: z.string().min(10, {message: "연락처 최소 10자리 이상입니다."}).max(11, { message: "최대 11자리까지 입력하실 수 있습니다."}),
    otp: z.string().length(6)
})

export const signupSchema = z.object({
    name: z.string().min(1, { message: "이름을 입력해주세요." }),
    birthdate: z.string().length(6, { message: "생년월일을 입력해주세요."}),
    jumin1: z.number().max(8),
    mobileno: z.string().min(10, {message: "연락처 최소 10자리 이상입니다."}).max(11, { message: "최대 11자리까지 입력하실 수 있습니다."}),
    mobileco: z.string(),
    otp: z.string().length(6),
    sidoCode: z.string(),
    sidoName: z.string(),
    sigunguCode: z.string(),
    sigunguName: z.string(),
    joinTermsAgreeList: z.object({
        termsId: z.number(),
        isAgreed: z.boolean()
    }).array()
})

export const updateSchema = z.object({
    name: z.string().min(1, { message: "이름을 입력해주세요." }),
    birthdate: z.string().length(6, { message: "생년월일을 입력해주세요."}),
    jumin1: z.number().max(8),
    mobileno: z.string().min(10, {message: "연락처 최소 10자리 이상입니다."}).max(11, { message: "최대 11자리까지 입력하실 수 있습니다."}),
    mobileco: z.string(),
    txId: z.string(),
    otp: z.string().length(6),
})
